module.exports = __webpack_public_path__ + "desktop-format-1.webm";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-start/assets/desktop-format-1.webm
// module id = 1167
// module chunks = 10